import { store } from "lib/store";
import { memberActionTypes } from "lib/store/member/reducer";
import client from "../client";

interface GetTransactionMemberHistoryGameRequest {
  start: number;
  limit: number;
  box: GetTransactionMemberHistoryGameResponse[];
}

export interface GetTransactionMemberHistoryGameResponse {
  ID?: number;
  CreatedAt?: Date;
  UpdatedAt?: Date;
  DisplayCreatedAt?: string;
  DisplayUpdatedAt?: string;
  AfterBetAmount?: number;
  Amount?: number;
  Games?: number;
  HashKey?: string;
  NameTH?: string;
  NameEN?: string;
  Symbol?: string;
  IPAddress?: string;
  VenderName?: string;
  Uncalculated?: boolean;
  StatusWinLost?: string;
  StatusWinLostColor?: string;
}

export default function API(
  request: GetTransactionMemberHistoryGameRequest
): Promise<GetTransactionMemberHistoryGameResponse> {
  return client
    .get(`members/get_transaction_member_history_game_byMember`, {
      params: { start: request.start, limit: request.limit },
    })
    .then((response) => response.data)
    .then((json) => {
      store.dispatch({
        type: memberActionTypes.ACTION_USER_UPDATE_TRANSACTION_PLAY_HISTORY,
        payload: [...request.box, ...json],
      });
      return json;
    });
}
